import moment from 'moment-timezone';

export const getLocationTimezone = (time_zone) => {
  if (time_zone === 'Asia/Singapore') return 'SGT';

  const momentTimezone = moment();
  return momentTimezone.tz(time_zone).format('z');
};
